export default __webpack_public_path__ + "static/background-d1368414577a8f8a4eb08ec8757f15c2.png";